import type { FunctionComponent } from "react"

import CalendarError from "@jobteaser/ui-kit/assets/pictograms/jds_pictogram_calendar_error.svg"
import { EmptyState } from "@jobteaser/ui-kit/components/EmptyState/EmptyState"

import { useCompanyFollowTrack } from "@/modules/companies/client/hooks/tracking/useCompanyFollowTrack"
import { useCompanyFollowerFetch } from "@/modules/companies/client/hooks/useCompanyFollowerFetch"
import { useFollowCompany } from "@/modules/companies/client/hooks/useFollowCompany"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

export const EventsEmptyStates: FunctionComponent = () => {
  const { dataCompanyFollower } = useCompanyFollowerFetch()
  const { followCompany, isLoadingFollowCompany } = useFollowCompany()
  const { t } = useTranslation(["companies_client"])
  const companyFollowTrack = useCompanyFollowTrack()

  const isFollowingCompany = !!dataCompanyFollower?.userInfo?.followsCompany
  const isAuthorizedToFollow = !!dataCompanyFollower?.userInfo?.authorizedToFollow

  let cta = null

  if (isAuthorizedToFollow && !isFollowingCompany) {
    cta = (
      <EmptyState.Button
        isLoading={isLoadingFollowCompany}
        onClick={() => {
          companyFollowTrack(true)
          followCompany(true)
        }}
      >
        {t("companies_client.newsFeed.events.emptyStates.action")}
      </EmptyState.Button>
    )
  }
  return (
    <EmptyState
      pictogram={CalendarError}
      title={t("companies_client.newsFeed.events.emptyStates.title")}
      description={t("companies_client.newsFeed.events.emptyStates.description")}
      data-testid="company_events_empty_states"
    >
      {cta}
    </EmptyState>
  )
}
